import React, { useEffect, useState } from 'react';
import { Stack, Dialog, DialogTitle, DialogContent, CircularProgress } from '@mui/material';
import { getUsersOnTraining } from '../services/trainingsService';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

export default function UsersOnTrainingDialog({ open, onClose, trainingId }) {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const intl = useIntl();

  const handleClose = () => {
    onClose(false);
  };

  useEffect(() => {
    const fetchUsersByTrainingId = async () => {
      try {
        // Call the endpoint to fetch the list of users by training ID
        const response = await getUsersOnTraining(trainingId);

        if (Array.isArray(response.data)) {
          setUsersData(response.data);
        } else {
          setUsersData([]);
        }
      } catch (error) {
        // Handle any errors
        console.error(error);
      } finally {
        setLoading(false); // Mark loading as false after the data is fetched
      }
    };

    if (open) {
      setLoading(true); // Set loading to true when the dialog is open
      fetchUsersByTrainingId();
    }
  }, [open, trainingId]);

  return (
    <Stack spacing={3}>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          {intl.formatMessage({
            id: 'training.usersOnTrainingDialog.title',
            defaultMessage: 'Signed up for training'
          })}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <CircularProgress />
          ) : usersData.length > 0 ? (
            <ul>
              {usersData.map((user, index) => (
                <li key={index}>{user.name}</li>
              ))}
            </ul>
          ) : (
            <p>
              {intl.formatMessage({
                id: 'training.usersOnTrainingDialog.noUsers',
                defaultMessage: 'No users available.'
              })}
            </p>
          )}
        </DialogContent>
      </Dialog>
    </Stack>
  );
}

UsersOnTrainingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  trainingId: PropTypes.number.isRequired,
};
